export var GetSatType;
(function (GetSatType) {
    GetSatType[GetSatType["DEFAULT"] = 0] = "DEFAULT";
    GetSatType[GetSatType["EXTRA_ONLY"] = 1] = "EXTRA_ONLY";
    GetSatType[GetSatType["POSITION_ONLY"] = 2] = "POSITION_ONLY";
    GetSatType[GetSatType["SKIP_POS_VEL"] = 3] = "SKIP_POS_VEL";
})(GetSatType || (GetSatType = {}));
export var ToastMsgType;
(function (ToastMsgType) {
    ToastMsgType["standby"] = "standby";
    ToastMsgType["normal"] = "normal";
    ToastMsgType["caution"] = "caution";
    ToastMsgType["serious"] = "serious";
    ToastMsgType["critical"] = "critical";
    ToastMsgType["error"] = "error";
})(ToastMsgType || (ToastMsgType = {}));
export var Pickable;
(function (Pickable) {
    Pickable[Pickable["Yes"] = 1] = "Yes";
    Pickable[Pickable["No"] = 0] = "No";
})(Pickable || (Pickable = {}));
export var MenuMode;
(function (MenuMode) {
    MenuMode[MenuMode["BASIC"] = 0] = "BASIC";
    MenuMode[MenuMode["ADVANCED"] = 1] = "ADVANCED";
    MenuMode[MenuMode["ANALYSIS"] = 2] = "ANALYSIS";
    MenuMode[MenuMode["EXPERIMENTAL"] = 3] = "EXPERIMENTAL";
    MenuMode[MenuMode["SETTINGS"] = 4] = "SETTINGS";
    MenuMode[MenuMode["ALL"] = 5] = "ALL";
})(MenuMode || (MenuMode = {}));
/**
 ***********************************************************
 * Singletons
 *
 * Using these interfaces will allow us to create replaceable
 * singletons. In the future, we can create new classes that
 * implement these interfaces and replace the singletons with
 * the new classes. Example: A new class that implements the
 * CatalogManager interface but is more resource intensive
 * for better accuracy.
 *
 * *********************************************************
 */
export var Singletons;
(function (Singletons) {
    Singletons["CatalogManager"] = "CatalogManager";
    Singletons["OrbitManager"] = "OrbitManager";
    Singletons["GroupsManager"] = "GroupManager";
    Singletons["UiManager"] = "UiManager";
    Singletons["ColorSchemeManager"] = "ColorScheme";
    Singletons["HoverManager"] = "HoverManager";
    Singletons["LineManager"] = "LineManager";
    Singletons["StarManager"] = "StarManager";
    Singletons["TimeManager"] = "TimeManager";
    Singletons["WebGLRenderer"] = "DrawManager";
    Singletons["DotsManager"] = "DotsManager";
    Singletons["SensorManager"] = "SensorManager";
    Singletons["SelectSatManager"] = "SelectSatManager";
    Singletons["InputManager"] = "InputManager";
    Singletons["SoundManager"] = "SoundManager";
    Singletons["SensorMath"] = "SensorMathManager";
    Singletons["MainCamera"] = "MainCamera";
    Singletons["PersistenceManager"] = "PersistenceManager";
    Singletons["Scene"] = "Scene";
    Singletons["MeshManager"] = "MeshManager";
})(Singletons || (Singletons = {}));
export var SolarBody;
(function (SolarBody) {
    SolarBody["Sun"] = "Sun";
    SolarBody["Mercury"] = "Mercury";
    SolarBody["Venus"] = "Venus";
    SolarBody["Earth"] = "Earth";
    SolarBody["Moon"] = "Moon";
    SolarBody["Mars"] = "Mars";
    SolarBody["Jupiter"] = "Jupiter";
    SolarBody["Saturn"] = "Saturn";
    SolarBody["Uranus"] = "Uranus";
    SolarBody["Neptune"] = "Neptune";
    SolarBody["Pluto"] = "Pluto";
    SolarBody["Makemake"] = "Makemake";
    SolarBody["Eris"] = "Eris";
    SolarBody["Haumea"] = "Haumea";
    SolarBody["Ceres"] = "Ceres";
    SolarBody["Io"] = "Io";
    SolarBody["Europa"] = "Europa";
    SolarBody["Ganymede"] = "Ganymede";
    SolarBody["Callisto"] = "Callisto";
    SolarBody["Titan"] = "Titan";
    SolarBody["Rhea"] = "Rhea";
    SolarBody["Iapetus"] = "Iapetus";
    SolarBody["Dione"] = "Dione";
    SolarBody["Tethys"] = "Tethys";
    SolarBody["Enceladus"] = "Enceladus";
})(SolarBody || (SolarBody = {}));
